export const requestParams = [
  "affid",
  // everflow
  "sub1",
  "sub2",
  "sub3",
  "sub4",
  "sub5",
  "uid",
  "oid",
  "source_id",
  "_ef_transaction_id",
  "fbclid",
  "gclid",
  //
  "sqdid",
  "c1",
  "c2",
  "c3",
  "click_id",
  "utm_medium",
  "utm_source",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "rtkclickid-store",
  // fb
  "_fbc",
  // twitter
  "twclid",
  // snapchat params for server side tracking
  "ScCid",
  "_scid",
  // tik tok tracking
  "ttclid",
];
